import { render, staticRenderFns } from "./prizeView.vue?vue&type=template&id=49b9841b&"
import script from "./prizeView.vue?vue&type=script&lang=js&"
export * from "./prizeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49b9841b')) {
      api.createRecord('49b9841b', component.options)
    } else {
      api.reload('49b9841b', component.options)
    }
    module.hot.accept("./prizeView.vue?vue&type=template&id=49b9841b&", function () {
      api.rerender('49b9841b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reservation/components/prizeView.vue"
export default component.exports